module.exports = __webpack_public_path__ + "img/ordTNiac1.bb68e42d.jpg";